/*
 * Copyright The OpenTelemetry Authors
 * SPDX-License-Identifier: Apache-2.0
 */
// Split module-level variable definition into separate files to allow
// tree-shaking on each api instance.
import { MetricsAPI } from './api/metrics';
/**
 * Entrypoint for metrics API
 *
 * @since 1.3.0
 */
export const metrics = MetricsAPI.getInstance();
//# sourceMappingURL=metrics-api.js.map